import { EpimsBaseEntityDto } from './epim-base.dto';
export class SectorDto extends EpimsBaseEntityDto {

    SectorId: string;

    SectorName: string;

   
    

}